<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Menu {{Title}}</h4>

        <div class="form-group">
          <label for="Parent">Parent</label>
          <ng-select [searchable]="false" [items]="Doc.ddlParent" required id="Parent" bindValue="value"
            bindLabel="text" [clearable]="false" #Parent="ngModel" [(ngModel)]="Doc.MenuPID">
          </ng-select>
        </div>

        <div class="form-group">
          <label for="MenuTitle">Menu Title *</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="MenuTitle" [(ngModel)]="Doc.MenuTitle"
              #MenuTitle="ngModel" aria-label="Menu Title" placeholder="" />
          </div>
          <div [hidden]="MenuTitle.valid || MenuTitle.pristine" class="alert alert-danger">
            Menu Title is required
          </div>
        </div>

        <div class="form-group">
          <label for="MenuLink">Menu Link * <small>Input # for root menu</small></label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="MenuLink" [(ngModel)]="Doc.MenuLink"
              #MenuLink="ngModel" aria-label="Menu Link" placeholder="" />
          </div>
          <div [hidden]="MenuLink.valid || MenuLink.pristine" class="alert alert-danger">
            Menu Link is required
          </div>
        </div>

        <div class="form-group">
          <label for="MenuBreadcrumb">Menu Breadcrumb</label>
          <div class="input-group">
            <input type="text" class="required form-control" id="MenuBreadcrumb" [(ngModel)]="Doc.MenuBreadcrumb"
              #MenuBreadcrumb="ngModel" aria-label="Menu Breadcrumb" placeholder="" />
          </div>
        </div>

        <div class="form-group">
          <label for="OrderSeq">Order Sequence</label>
          <div class="input-group">
            <input type="number" class="required form-control" required id="OrderSeq" [(ngModel)]="Doc.OrderSeq"
              #OrderSeq="ngModel" aria-label="Order Sequence" placeholder="0" />
          </div>
          <div [hidden]="OrderSeq.valid || OrderSeq.pristine" class="alert alert-danger">
            Order Sequence is required
          </div>
        </div>

        <div class="form-group">
          <label for="MenuIcon">Menu Icon *</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="MenuIcon" [(ngModel)]="Doc.MenuIcon"
              #MenuIcon="ngModel" aria-label="Menu Icon" placeholder="fas fa-search" />
          </div>
          <div [hidden]="MenuIcon.valid || MenuIcon.pristine" class="alert alert-danger">
            Menu Icon is required
          </div>
        </div>

        <div class="form-group">
          <label for="IsDisplayed">IsDisplayed</label>
          <ng-select [searchable]="false" [items]="Doc.ddlDisplay" id="IsDisplayed" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.SelectedDisplay">
          </ng-select>
        </div>

        <p>(*) Mandatory</p>
      </div>
      <div class="border-top">
        <div class="card-body">
          <button (click)="Cancel()" class="btn btn-outline-secondary" role="button">Cancel</button>
          <button (click)="Submit()" class="btn btn-success ml-1" role="button" [disabled]="isValid()">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Container fluid  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <footer class="footer text-center"></footer>
  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->
</div>
